<template>
  <div class="courses">
    <div class="courses-list" v-for="(item, index) in courses" :key="index">
      <!-- fix issue #2378 -->
      <img
        :src="(item.cover ? item.cover.url : defaultImg) | handleImageUrl('228', '130')"
        class="section-img"
        @click="goPage(item.id)">
      <!-- fix issue #2007 -->
      <div :class="item.cover ? 'has-course-content' : 'no-course-content'">
        <!-- finish #2531 -->
        <div class="course-title" @click="goPage(item.id)" v-if="item.year">{{ item.year + item.title }}</div>
        <div class="course-title" @click="goPage(item.id)" v-else>{{ item.title }}</div>
        <div class="course-label">
          <div class="course-label-item hourse" v-if="item.hours == null">0课时</div>
          <div class="course-label-item hourse" v-else>{{ item.hours }}课时</div>
          <div class="course-label-item">已有{{ item.hits }}人观看</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const StaticUrl = process.env.VUE_APP_CDN;
export default {
  props: {
    courses: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      defaultImg: StaticUrl + 'img-cover.jpg',
    }
  },
  methods: {
    goPage(id) {
      window.location.href = `/course/view.html?id=${id}`;
    }
  }
}
</script>
<style scoped>
.courses-list {
  display: flex;
  margin-top: 25px;
  padding: 0 25px;
  height: 130px;
  box-sizing: border-box;
}

.section-img {
  margin-right: 25px;
  width: 228px;
  height: 130px;
}

.has-course-content {
  width: 416px;
}

.no-course-content {
  width: 100%;
}
.course-title {
  margin-bottom: 15px;
  height: 66px;
  line-height: 33px;
  font-size: 30px;
  color: #000;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.course-label {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.course-label-item {
  font-size: 24px;
  color: #999;
}

.hourse {
  margin-right: 22px;
  color: #3e8dfd;
}
</style>
